import React, {
  Component,
  useState,
  useEffect,
  useContext,
  forwardRef,
} from "react";
import { Card, OverlayTrigger, Tooltip, Table } from "react-bootstrap";
import { IoSearch } from "react-icons/io5";

import { AES, enc } from "crypto-js";
import "datatables.net-responsive-dt";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-dt/js/dataTables.dataTables.js";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useNavigate } from "react-router-dom";
import { TokenContext } from "../AuthProvider";
import Header from "../Header";
import Footer from "../Footer";

import RecentItems from "../recentItems/RecentItems";
import $ from "jquery";
import { parse, format, isValid } from "date-fns";
import DatePicker from "react-datepicker";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";
import Popup from "reactjs-popup";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Editor from "react-simple-wysiwyg";
import { API_URL } from "../config";
import {
  FaEnvelope,
  FaPhoneSquareAlt,
  FaMobileAlt,
  FaFax,
} from "react-icons/fa";
import axios from "axios";
import { BsFillEnvelopeFill } from "react-icons/bs";
import { FaPencilAlt, FaTrashAlt, FaPlus } from "react-icons/fa";
// import { decryptedAccessToken, encryptedAccessToken } from "../../Token";
import { useParams } from "react-router-dom";
const Receiptdetails = () => {
  const secret_key = "4d3a23fba54bbef1e14dd44ba9591612";
  const encryptedAccessToken = localStorage.getItem("access_token");
  const decryptedAccessToken = encryptedAccessToken
    ? AES.decrypt(encryptedAccessToken, secret_key).toString(enc.Utf8)
    : null;

    const [dataBank, setDataBank] = useState([]);

  const params = useParams();
  const id = params.id;

  console.log(id, "ids");
  const userRole = localStorage.getItem("role");
  console.log(userRole);
  const { username, token } = useContext(TokenContext);
  const [datas, setDatas] = useState([]);
  const [line, setLine] = useState([]);
  const [OrderID, setOrderId] = useState(null);
  const [paymentDate, setPaymentDate] = useState(null);

  const [lineitemDetail, setlineItemDetail] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [lockedCheck, setLockedCheck] = useState(false);


  const [selectedProductCode, setSelectedProductCode] = useState("");
  const [lineitemText, setLineitemText] = useState("");

  const handleClear = () => {
    setSelectedProductCode("");
    setIsPopupOpen(true); // Open the popup
  };


  const [bill, setBill] = useState([]);

  useEffect(() => {
    fetchBankDatas();
  }, [decryptedAccessToken]);

  const fetchBankDatas = async () => {
    try {
      const response = await axios.get(API_URL + "get/all/rwoodbank", {
        headers: { Authorization: `Bearer ${decryptedAccessToken}` },
      });
      console.log(response);
      const data = response.data.rwood_bank;
      setDataBank(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (OrderID) {
      const fetchOrderDetails = async () => {
        try {
          console.log("Fetching order details for OrderID:", OrderID);
          const orderResponse = await axios.get(
            `${API_URL}get/order_pay_recieve/${OrderID}`,
            {
              headers: { Authorization: `Bearer ${decryptedAccessToken}` },
            }
          );
          console.log(orderResponse);
          const data = orderResponse.data.pay_recieve_detail;

          setBill(data);
        } catch (error) {
          console.error("Error fetching order details:", error);
        }
      };

      fetchOrderDetails();
    }
  }, [OrderID, decryptedAccessToken]);

  const handleRowClick = (productCode, lineItem) => {
    setSelectedProductCode(productCode); // Update selected product code
    setLineitemText(lineItem); // Update selected line item
    setIsPopupOpen(false); // Close the popup

    // Update formData1 with the selected product code, line item, and id
    setFormData1((prevFormData) => {
      const updatedFormData = [...prevFormData];

      // Update line item type, line item, and id
      updatedFormData[0] = {
        ...updatedFormData[0],
        line_item_type: productCode,
        line_item: lineItem,
      };

      // Debugging logs
      console.log("Updated formData1:", updatedFormData);

      return updatedFormData; // Return the updated form data
    });
  };




  useEffect(() => {
    fetchLineitemDetail();
  }, [decryptedAccessToken]);

  const fetchLineitemDetail = async () => {
    try {
      const response = await axios.get(
        API_URL + "get/all/pay_recieve_lineitem",
        {
          headers: { Authorization: `Bearer ${decryptedAccessToken}` },
        }
      );
      console.log(response, "lineitem");
      const data = response.data.pay_lineitem_all;
      setlineItemDetail(data);
    } catch (error) {
      console.error(error);
    }
  };

  const [bank, setBank] = useState([]);
  useEffect(() => {
    fetchDatasBank();
  }, [decryptedAccessToken]);

  const fetchDatasBank = async () => {
    try {
      const response = await axios.get(API_URL + "get/all/rwoodbank", {
        headers: { Authorization: `Bearer ${decryptedAccessToken}` },
      });
      console.log(response);
      const data = response.data.rwood_bank;
      setBank(data);
    } catch (error) {
      console.error(error);
    }
  };

  const [startDate1, setStartDate1] = useState(null);

  const[receiptDetail, setreceiptDetail]=useState([])

  const [document, setDocument] = useState(null);
  const [actual, setActual] = useState(null);

  // receipt_detail

  useEffect(() => {
    fetchData();
  }, [decryptedAccessToken]);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        API_URL + "get/rw_receipt_lineitem_by_id/" + id,
        {
          headers: { Authorization: `Bearer ${decryptedAccessToken}` },
        }
      );
      // Safely set OrderID

      const data = response.data.receipt_lineitem[0];
      setreceiptDetail(response.data.receipt_detail)


      const payment_date =
      response.data.receipt_detail[0].payment_receipt_date;
      const document_date =
        response.data.receipt_detail[0].document_discount_date;
      const actual_date =
        response.data.receipt_detail[0].actual_payment_recieved_date;

      if (payment_date !== null) {
        const defaultDatepicker = parse(payment_date, "dd/MM/yyyy", new Date());
        setPaymentDate(defaultDatepicker);
      } else {
        setPaymentDate(new Date());
      }


      if (document_date !== null) {
        const defaultDatepicker = parse(
          document_date,
          "dd/MM/yyyy",
          new Date()
        );
        setDocument(defaultDatepicker);
      } else {
        setDocument(new Date());
      }

      if (actual_date !== null) {
        const defaultDatepicker = parse(actual_date, "dd/MM/yyyy", new Date());
        setActual(defaultDatepicker);
      } else {
        setActual(new Date());
      }
      console.log(response.data.receipt_detail, response.data.receipt_detail)
      console.log(data, "response data");
      setOrderId(data.order_id);
      setLine(response.data.receipt_lineitem);

      setDatas(data);
      $("#tables-pay").DataTable();
      let payment_receipt_date = data.payment_receipt_date;

      if (payment_receipt_date !== null) {
        const defaultDatepicker = parse(
          payment_receipt_date,
          "dd/MM/yyyy",
          new Date()
        );
        setStartDate1(defaultDatepicker);
      } else {
        setStartDate1(new Date());
      }
    } catch (error) {
      console.error(error);
    }
  };



  const [accountName, setAccountName] = useState([]);
  useEffect(() => {
    fetchDataSupplier();
  }, [decryptedAccessToken]);

  const fetchDataSupplier = async () => {
    try {
      const response = await axios.get(API_URL + "all/accounts", {
        headers: { Authorization: `Bearer ${decryptedAccessToken}` },
      });
      const data = response.data.accounts;
      setAccountName(data);
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };

  // const [accountName, setAccountName] = useState([]);
  // useEffect(() => {
  //   fetchDataSupplier();
  // }, [decryptedAccessToken]);

  // const fetchDataSupplier = async () => {
  //   try {
  //     const response = await axios.get(API_URL + "get/buyer", {
  //       headers: { Authorization: `Bearer ${decryptedAccessToken}` },
  //     });
  //     const data = response.data;
  //     setAccountName(data);
  //     console.log(data);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setDatas({ ...datas, [name]: value });
  };
  const handleChange2 = (e) => {
    const { name, value } = e.target;
    setDatas({ ...datas, [name]: value });
  };

  useEffect(() => {
    if (datas.description) {
      setEditor1(datas.description);
    }
  }, [datas]);

  const [bdate, setbirthDate] = useState("");
  useEffect(() => {
    const dateObject = new Date(startDate1);
    if (dateObject) {
      const formattedDate = format(dateObject, "dd/MM/yyyy", {
        timeZone: "UTC",
      });
      setbirthDate(formattedDate);
      console.log(formattedDate);
    }
  });

  const [editor1, setEditor1] = useState(datas.description);
  function onChanges(e) {
    console.log("onChange event:", e);
    console.log("Current HTML:", e.target.value);
    setEditor1(e.target.value);
  }

  const [finance, setFinance] = useState([]);

  const lineItemLists = async () => {
    if (OrderID) {
      try {
        const response = await axios.post(
          API_URL + "get/all/financeconfig/orders",
          { record_type: datas.record_type },
          {
            headers: {
              Authorization: `Bearer ${decryptedAccessToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        console.log(response);
        const data = response.data.all_finance;
        setFinance(data);
      } catch (error) {
        console.error(error);
      }
    }
  };

  // Automatically call the API when record_type or decryptedAccessToken changes
  useEffect(() => {
    if (datas.record_type) {
      lineItemLists();
    }
  }, [datas.record_type, decryptedAccessToken]);

  const [lineitems, setLineitems] = useState([]);

  const fetchDatas = async () => {
      if (OrderID) {
        try {
          const response = await axios.get(
            `${API_URL}get/order_pay_recieve_lineitem/${OrderID}`,
            {
              headers: { Authorization: `Bearer ${decryptedAccessToken}` },
            }
          );
          console.log("*********************", response);
          const data = response.data.pay_lineitem_detail;

          setLineitems(data);
        } catch (error) {
          console.error(error);
        }
      }
    };
  useEffect(() => {
    fetchDatas();
  }, [OrderID, decryptedAccessToken]);



  // edit option
  const [data, setData] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [editedData, setEditedData] = useState([]);
  const handleEditClick = () => {
    setIsEditMode(true);
    setEditedData(data);
  };

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setDatas((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCancelEdit = () => {
    setIsEditMode(false);
    setEditedData(data);
    $("#tables-pay").DataTable();
  };
  const mapData = () => {
    if (line.length > 0) {
      const mappedData = {};

      line.forEach((item) => {
        const id = item.id;

        if (!mappedData[id]) {
          mappedData[id] = [];
        }

        mappedData[id].push({
          order: item.order,
          id: item.id,
          rw_pay_receivable_lineitem: item.rw_pay_receivable_lineitem,
          rw_billing: item.rw_billing,
          line_item_type: item.line_item_type,
          line_item: item.line_item,
          amount: item.amount,
          description: item.description,
          vessel_name: item.vessel_name,
        });
      });

      // Combine all the arrays into a single array
      const combinedData = Object.values(mappedData).reduce(
        (result, data) => [...result, ...data],
        []
      );

      setFormData1(combinedData);
    }
  };


  // Call the mapData function when needed, e.g., when formData2 changes
  useEffect(() => {
    mapData();
  }, [line]);






  const [formData1, setFormData1] = useState([
    {
      order: "",
      id: "",
      rw_pay_receivable_lineitem: "",
      rw_billing: "",
      line_item_type: selectedProductCode,
      line_item: "",
      amount: "",
      description: editor1,
      vessel_name: "",
    },
  ]);










  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  useEffect(() => {
    setIsButtonEnabled(true);
  }, []);

  const [lockeds, setLockeds] = useState(null);
  const [payments, setPayments] = useState(null);

  const chek_bok = datas.locked;
  const chek_payment = datas.payment;
  useEffect(() => {
    setLockeds(chek_bok);
    setPayments(chek_payment);
  }, [chek_bok, chek_payment]); // Run this effect whenever tt changes

  useEffect(() => {}, [lockeds, payments]); // Run

  const handleCheckboxChange1 = (e) => {
    setLockeds(e.target.checked);
  };
  const handleCheckboxChange2 = (e) => {
    setPayments(e.target.checked);
  };

  const handleInputChange = (index, event) => {
    const { name, value } = event.target;

    setFormData1((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        [name]: value,
      };

      return updated;
    });

    if (name === "line_item") {
      setLineitemText(value); // Update lineitemText state
    }
  };

  const adminRole = localStorage.getItem("role");
  console.log(formData1);
  const handleSaveEdit = (e) => {
    e.preventDefault();
    $("#tables-pay").DataTable();
    const requestData = {
      //
      receipt_update: formData1,
    };

    const order_detail = receiptDetail.map(detail => ({
      currency: detail.currency,
      exchange_rate: detail.exchange_rate,
      company: detail.company,
      record_type: detail.record_type,

      owner: detail.owner,
      document_reference_no: detail.payment_receipt_ref_no, // Assuming this is what you want
      debit_note_no: detail.rw_payment_receipt, // Adjust based on your needs
      recieve_status: detail.receipt_status,
      document_date: detail.payment_receipt_date, // Assuming document_date corresponds to payment_receipt_date
      rwood_bank_master: detail.rwood_bank_master,
      description: detail.description,
      locked: detail.locked,
      payment: detail.total_amount, // Assuming payment corresponds to total_amount
      account: detail.account,
    }));

    console.log(JSON.stringify(order_detail));
    // console.log(JSON.stringify(requestData))
    fetch(`${API_URL}update/rw_pay_receipt_detail/${id}`, {
      method: "PUT",
      body: JSON.stringify(order_detail),
      headers: {
        Authorization: `Bearer ${decryptedAccessToken}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((updatedData) => {
        // console.log(updatedData)
        // if(updatedData.msg==="Updated successfully"){
        console.log(JSON.stringify(formData1));
        fetch(`${API_URL}update/rw_pay_receipt/${id}`, {
          method: "PUT",
          body: JSON.stringify(requestData),
          headers: {
            Authorization: `Bearer ${decryptedAccessToken}`,
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((updatedData) => {
            console.log(updatedData);
            fetchData();
            // navigate(`/order/view-order-details/${id}`)

            // console.log(updatedData)
            $("#table").DataTable();
          });
        // }

        setData(updatedData);
        setIsEditMode(false);
      })
      .catch((error) => console.error(error));
  };

  const [company, setCompany] = useState([]);
  useEffect(() => {
    fetchDataAccount();
  }, [decryptedAccessToken]);

  const fetchDataAccount = async () => {
    $("tables").DataTable();
    try {
      const response = await axios.get(API_URL + "get/all/rwoodcompany", {
        headers: { Authorization: `Bearer ${decryptedAccessToken}` },
      });
      const data = response.data.rwoodcompany;
      setCompany(data);
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };




  return (
    <div id="view-page" className="lineitem-receipt">
      <Header />
      <div className="row">
      <div className="col-md-2">
            <RecentItems/>
          </div>
          <div className="col-md-10">
      <div className="contactAccount">
        <div className="page-header btn-margin" id="add-account">
          <div>
            <h2 className="main-content-title tx-24 mg-b-5">
              RW Payment/Receipt LineItem Detail
            </h2>
            <ol className="breadcrumb">
              <li className="breadcrumb-item active" aria-current="page">
                Dashboard / RW Payment/Receipt LineItem / Detail
              </li>
            </ol>
          </div>
        </div>
        {isEditMode ? (
          <>
            <div className="tasks">
              <p className="edit-btn">
                <button className="btn btn-primary" onClick={handleSaveEdit}>
                  Save
                </button>
                <button className="btn btn-primary" onClick={handleCancelEdit}>
                  Cancel
                </button>
              </p>
              <Row className="mb-3">
              <h4 className="heading">RW Payment/Receipt Information</h4>
                <Form.Group as={Col} md="6">
                  <FloatingLabel
                    controlId="floatingInput"
                    label="Record Type"
                    className="mb-3"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Record Type"
                      name="record_type"
                      defaultValue={datas.record_type}
                      onChange={handleChangeInput}
                    />
                  </FloatingLabel>
                </Form.Group>
                <Form.Group as={Col} md="6" id="lockeds">
                  <input
                    type="checkbox"
                    name="locked"
                    onChange={(e) => setLockedCheck(e.target.checked)}
                  />
                  <label>Locked</label>
                </Form.Group>

                <Form.Group as={Col} md="6">
                  <FloatingLabel
                    controlId="floatingSelect"
                    className="dropDown"
                    label="Account"
                  >
                    <Form.Select
                      aria-label="Floating label select example"
                      name="account"
                      placeholder="Account"
                      value={datas.account}
                      onChange={handleChangeInput}
                    >
                      <option value="">Select</option>
                      {accountName.length > 0 ? (
                        <>
                          {accountName.map((x) => {
                            return (
                              <option value={x.account_name}>
                                {x.account_name}
                              </option>
                            );
                          })}
                        </>
                      ) : (
                        <option className="no-data">No data available</option>
                      )}
                    </Form.Select>
                  </FloatingLabel>
                </Form.Group>

                <Form.Group as={Col} md="6"></Form.Group>
                {/* <Form.Group as={Col} md="6">
                  <FloatingLabel
                    controlId="floatingSelect"
                    className="dropDown"
                    label="Company"
                  >
                    <Form.Select
                      aria-label="Floating label select example"
                      name="company"
                      placeholder="Company"
                      defaultValue={datas.company || ""}
                      onChange={handleChangeInput}
                    >
                      <option value="">Select</option>
                      {company.map((x) => {
                        return (
                          <option value={x.company_name}>
                            {x.company_name}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </FloatingLabel>
                </Form.Group> */}

                <Form.Group as={Col} md="6">
                  <FloatingLabel
                    controlId="floatingSelect"
                    className="dropDown"
                    label="Company"
                  >
                    <Form.Select
                      aria-label="Floating label select example"
                      name="company"
                      placeholder="Company"
                      value={datas?.company || ""}
                      onChange={handleChangeInput}
                    >
                      <option value="" disabled>
                        Select
                      </option>

                      {company.map((x) => (
                        <option
                          key={x.rwood_company_code}
                          value={x.rwood_company_code}
                        >
                          {x.rwood_company_code}
                        </option>
                      ))}
                    </Form.Select>
                  </FloatingLabel>
                </Form.Group>
                <Form.Group as={Col} md="6">
                  <FloatingLabel
                    controlId="floatingInput"
                    label="payment receipt ref no"
                    className="mb-3"
                  >
                    <Form.Control
                      type="text"
                      placeholder="payment receipt ref no"
                      name="payment_receipt_ref_no"
                      className="clear"
                      defaultValue={datas.payment_receipt_ref_no || ""}
                      onChange={handleChangeInput}
                    />
                  </FloatingLabel>
                </Form.Group>

                <Form.Group as={Col} md="6">
                  <FloatingLabel
                    controlId="floatingSelect"
                    className="dropDown"
                    label="bank master"
                  >
                    <Form.Select
                      aria-label="Floating label select example"
                      name="rwood_bank_master"
                      placeholder="bank master master"
                      defaultValue={datas.rwood_bank_master || ""}
                      onChange={handleChangeInput}
                    >
                      <option value="" disabled>
                        Select
                      </option>
                      {dataBank.map((x) => {
                        return (
                          <option value={x.rwood_bank_name}>
                            {x.rwood_bank_name}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </FloatingLabel>
                </Form.Group>

                <Form.Group as={Col} md="6">
                  <FloatingLabel
                    controlId="floatingInput"
                    label="Payment Receipt Date"
                    className="mb-3 datepick"
                  >
                    <DatePicker
                      selected={paymentDate}
                      onChange={(date) => setPaymentDate(date)}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="Select a date"
                    />
                  </FloatingLabel>
                </Form.Group>
                <Form.Group as={Col} md="6">
                  <FloatingLabel
                    controlId="floatingSelect"
                    className="dropDown"
                    label="mode of payment"
                  >
                    <Form.Select
                      aria-label="Floating label select example"
                      name="mode_of_payment"
                      placeholder="mode of payment"
                      defaultValue={datas.mode_of_payment || ""}
                      onChange={handleChangeInput}
                    >
                      <option value="">--None--</option>
                      <option value="Letter Of Credit" selected="selected">
                        Letter Of Credit
                      </option>
                      <option value="Telegraphic Transfer">
                        Telegraphic Transfer
                      </option>
                      <option value="Cheque">Cheque</option>
                      <option value="Cash">Cash</option>
                    </Form.Select>
                  </FloatingLabel>
                </Form.Group>
                <Form.Group as={Col} md="6">
                  <FloatingLabel
                    controlId="floatingInput"
                    label="document discount date"
                    className="mb-3 datepick"
                  >
                    <DatePicker
                      selected={document}
                      onChange={(date) => setDocument(date)}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="Select a date"
                    />
                  </FloatingLabel>
                </Form.Group>

                <Form.Group as={Col} md="6">
                  <FloatingLabel
                    controlId="floatingInput"
                    label="actual payment recieved date"
                    className="mb-3 datepick"
                  >
                    <DatePicker
                      selected={actual}
                      onChange={(date) => setActual(date)}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="Select a date"
                    />
                  </FloatingLabel>
                </Form.Group>

                <Form.Group as={Col} md="6">
                  <FloatingLabel
                    controlId="floatingSelect"
                    className="dropDown"
                    label="receipt_status"
                  >
                    <Form.Select
                      aria-label="Floating label select example"
                      name="receipt_status"
                      placeholder="receipt_status"
                      defaultValue={datas.receipt_status || ""}
                      onChange={handleChangeInput}
                      className="clear"
                    >
                                        <option value="" selected="selected">
        --None--
      </option>

                      <option value="Raised">
                        Raised
                      </option>
                      <option value="Paid">Paid</option>
                      <option value="Partial Payment">Partial Payment</option>
                      <option value="Adjusted">Adjusted</option>
                      <option value="Cancelled">Cancelled</option>
                      <option value="Settled By Arutmin">
                        Settled By Arutmin
                      </option>
                    </Form.Select>
                  </FloatingLabel>
                </Form.Group>
                <Form.Group as={Col} md="6">
                  <FloatingLabel
                    controlId="floatingInput"
                    label="Total Amount"
                    className="mb-3"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Total Amount"
                      name="total_amount"
                      className="clear"
                      defaultValue={datas.total_amount || ""}
                      onChange={handleChangeInput}
                    />
                  </FloatingLabel>
                </Form.Group>
                <Form.Group as={Col} md="6">
                  <label>Description</label>
                  <Editor
                    value={editor1}
                    name="description"
                    onChange={onChanges}
                  />
                </Form.Group>
              </Row>
              <table id="rw-table" className="table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Rw Payable/ Receivable LineItem</th>
                    <th>RW Billing</th>
                    <th>Line item type</th>
                    <th>Line item</th>
                    <th>Order</th>
                    <th>Amount</th>
                    <th>Description</th>
                    <th>Vessel Name</th>
                    <th>BL Date</th>
                  </tr>
                </thead>
                <tbody>
                  {formData1.map((x, index) => (
                    <>
                      {line.map((y, index) => (
                        <tr key={index}>
                          <td>
                            <input
                              type="text"
                              name="id"
                              className="form-control clear"
                              placeholder="id"
                              defaultValue={x.id}
                              onChange={(e) => handleInputChange(index, e)}
                            />
                          </td>


                          <td>
                            <select
                              type="text"
                              name="rw_pay_receivable_lineitem"
                              className="form-control clear"
                              defaultValue={x.rw_pay_receivable_lineitem || y.rw_pay_receivable_lineitem}
                              onChange={(e) => handleInputChange(index, e)}
                            >
                              <option>---None--</option>
                              {lineitems.map((x, index) => (
                                <>
                                  <option
                                    value={x.rw_pay_receivable_lineitem}
                                  >
                                    {x.rw_pay_receivable_lineitem}
                                  </option>
                                  {/* <option value='RW-PR_LI-01-0023'>RW-PR_LI-01-0023</option> */}
                                </>
                              ))}
                            </select>
                          </td>

                          <td>
                            <select
                              type="text"
                              name="rw_billing"
                              className="form-control clear"
                              defaultValue={x.rw_billing || y.rw_billing}
                              onChange={(e) => handleInputChange(index, e)}
                            >
                              <option>---None--</option>
                              {lineitems?.map((x,index) => (
                                <>
                                  <option value={x.rw_billing}>
                                    {x.rw_billing}
                                  </option>
                                  {/* <option value='RW-PR_LI-01-0023'>RW-PR_LI-01-0023</option> */}
                                </>
                              ))}
                            </select>
                          </td>
                          <td>
                            <div className="lineGroup">
                              <input
                                type="text"
                                placeholder="Line Item Type"
                                name="line_item_type"
                                id="line_item_clear"
                                value={selectedProductCode || y.line_item_type}
                                // Handle input change
                                onChange={(e) => {
                                  const newValue = e.target.value;
                                  setFormData1((prev) => {
                                    const updated = [...prev];
                                    updated[0].line_item_type = newValue; // Update the line item type
                                    return updated; // Return the updated form data
                                  });
                                }}
                              />
                              <button
                                className="button select-search"
                                onClick={handleClear}
                              >
                                <IoSearch />
                              </button>
                            </div>

                            <Popup
                              open={isPopupOpen}
                              onClose={() => setIsPopupOpen(false)}
                              modal
                            >
                              <table className="table table-hovered">
                                <thead>
                                  <tr>
                                    <th>Billing Config Name</th>
                                    <th>Line Item</th>
                                    <th>Lineitem Type</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {finance.map((y, i) => (
                                    <tr
                                      key={i}
                                      onClick={() =>
                                        handleRowClick(
                                          y.billing_config_name,
                                          y.line_item
                                        )
                                      }
                                    >
                                      <td>{y.billing_config_name}</td>
                                      <td>{y.line_item}</td>
                                      <td>{y.lineitem_type}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </Popup>
                            {/* <select className="form-control lineitem"
         name="line_item_type"
         defaultValue={x.line_item_type  ||y.line_item_type}
         onChange={(e) => handleInputChange(index, e)}>
            <option>---None---</option>
          {finance.map((x, idx) => (
            <option key={idx} value={x.billing_config_name}>{x.billing_config_name}</option>
          ))}
        </select> */}
                          </td>

                          {/* <td>
                  <select className="form-control lineitem"
                  name='line_item_type'
                  defaultValue={x.line_item_type}
                  onChange={(e) => handleInputChange(index, e)} >
                     <option>---None--</option>
                  {lineItem?.map((x) => (

                    <option value={x.billing_config_name}>{x.billing_config_name}</option>


                  ))}
                  </select>
                  </td> */}

                          <td>
                            <input
                              type="text"
                              name="line_item"
                              placeholder="Line item"
                              id="line_item_clear"
                              value={lineitemText || y.line_item}
                              className="form-control clear"
                              onChange={(e) => handleInputChange(index, e)}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              name="order"
                              placeholder="Order"
                              className="form-control"
                              // /value={formData1[index].currency !== undefined ? formData1[index].currency : ""}

                              defaultValue={x.order}
                              onChange={(e) => handleInputChange(index, e)}
                            />
                          </td>


                          <td>
                            <input
                              type="text"
                              name="amount"
                              placeholder="Amount"
                              defaultValue={x.amount}
                              className="form-control clear"
                              onChange={(e) => handleInputChange(index, e)}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              name="description"
                              placeholder="Description"
                              defaultValue={x.description}
                              className="form-control clear"
                              onChange={(e) => handleInputChange(index, e)}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              name="vessel_name"
                              placeholder="Vessel name"
                              defaultValue={x.vessel_name}
                              className="form-control clear"
                              onChange={(e) => handleInputChange(index, e)}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              name="bl_date"
                              placeholder="BL Date"
                              defaultValue={x.bl_date}
                              className="form-control clear"
                              onChange={(e) => handleInputChange(index, e)}
                            />
                          </td>
                        </tr>
                      ))}
                    </>
                  ))}
                </tbody>
              </table>
              <p className="edit-btn">
                <button className="btn btn-primary" onClick={handleSaveEdit}>
                  Save
                </button>
                <button className="btn btn-primary" onClick={handleCancelEdit}>
                  Cancel
                </button>
              </p>
            </div>
          </>
        ) : (
          <div className="tasks">
            <p className="edit-cancel">
              <input
                type="submit"
                className="account-save"
                value="Edit"
                onClick={handleEditClick}
              />{" "}
              {datas.order_id ? (
                <Link to={`/order/view-order-details/${datas.order_id}`}>
                  <input
                    type="submit"
                    className="account-save"
                    value="Cancel"
                  />
                </Link>
              ) : (
                <Link to="/receipt-lineitem/list-view">
                  <input
                    type="submit"
                    className="account-save"
                    value="Cancel"
                  />
                </Link>
              )}
              {/* <Link to={`/order/view-order-details/${datas.order_id}`}>
                <input type="submit" className="account-save" value="Cancel" />
              </Link> */}
            </p>
            <div className="row">
              <div className="col-md-12" id="head">
                <h4 className="heading">
                  <span>RW Payable/Receipt Detail</span>
                </h4>
                <hr></hr>
              </div>
            </div>
            <table class="table table-bordered account-table tables">
              <tbody>
                <tr>
                  <td id="td-right">
                    <span>Rw Payable/ Receipt LineItem </span>
                  </td>
                  <td>{datas.rw_payment_receipt_name}</td>
                  <td id="td-right">
                    <span>Locked</span>
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      name="locked"
                      checked={payments} // Use the state variable to determine if the checkbox is checked
                      onChange={handleCheckboxChange2} // Handle the change event
                      className="mx-3"
                      disabled={isButtonEnabled}
                    />
                  </td>
                </tr>
                <tr>
                  <td id="td-right">
                    <span>currency</span>
                  </td>
                  <td>{datas.currency}</td>{" "}
                  <td id="td-right">
                    <span>record type</span>
                  </td>
                  <td>{datas.record_type}</td>
                </tr>
                <tr>
                  <td id="td-right">
                    <span>exchange rate</span>
                  </td>
                  <td>{datas.exchange_rate}</td>
                  <td id="td-right">
                    <span>RW Billing </span>
                  </td>
                  <td>{datas.rw_billing}</td>
                </tr>
                <tr>
                  <td id="td-right">
                    <span>SrNo</span>
                  </td>
                  <td>{datas.sr_no}</td>
                  <td id="td-right">
                    <span>Document Date </span>
                  </td>
                  <td>{datas.document_date}</td>
                </tr>
                <tr>
                  <td id="td-right">
                    <span>Line Item </span>
                  </td>
                  <td>{datas.line_item}</td>
                  <td id="td-right">
                    <span>Company</span>
                  </td>
                  <td>
                    <Link
                      to={`/company/company-details/${datas.rwoodcompany_id}`}
                    >
                      {datas.company}
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td id="td-right">
                    <span>Unit Rate </span>
                  </td>
                  <td>{datas.unit_rate}</td>

                  <td id="td-right">
                    <span>Amount in Words </span>
                  </td>
                  <td>{datas.amount_in_words}</td>
                </tr>
                <tr>
                  <td id="td-right">
                    <span>Quantity</span>
                  </td>
                  <td>{datas.quantity}</td>
                  <td id="td-right">{/* <span>rwood bank master</span> */}</td>
                  <td>{/* {datas.rwood_bank_master} */}</td>
                </tr>
                <tr>
                  <td id="td-right">
                    <span>Amount</span>
                  </td>
                  <td>{datas.amount}</td>

                  <td id="td-right">
                    <span>Paid / Received Date </span>
                  </td>
                  <td>{datas.paid_recieved_date}</td>
                </tr>
                <tr>
                  <td id="td-right">
                    <span>Balance Due</span>
                  </td>
                  <td>{datas.balance_due}</td>
                  <td id="td-right">
                    <span>Paid / Received Amount</span>
                  </td>
                  <td>{datas.paid_recieved_amount}</td>
                </tr>
              </tbody>
            </table>

            {/* <div className="row">siva
           <div className="col-md-12" id="head">
             <h4 className="heading">RW Payable/Receivable Detail
</h4>
             <hr></hr>
           </div>
         </div> */}
            <div className="row">
              <div className="col-md-12" id="head">
                <h4 className="heading">Vessel Details</h4>
                <hr></hr>
              </div>
            </div>
            <table class="table table-bordered account-table tables">
              <tbody>
                <tr>
                  <td id="td-right">
                    <span>Vessel Name </span>
                  </td>
                  <td>{datas.vessel_name}</td>
                  <td id="td-right">
                    <span>Destination</span>
                  </td>
                  <td>{datas.destination}</td>
                </tr>
                <tr>
                  <td id="td-right">
                    <span>BL Date </span>
                  </td>
                  <td>{datas.bl_date}</td>
                  <td id="td-right">
                    <span>Contract</span>
                  </td>
                  <td>
                    <Link
                      to={`/contract/contract-details/${datas.contract_id}`}
                    >
                      {" "}
                      {datas.contract}
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td id="td-right">
                    <span>Account </span>
                  </td>
                  <td>
                    <Link to={`/accounts/${datas.account_id}`}>
                      {datas.account}
                    </Link>
                  </td>
                  <td id="td-right">
                    <span>Surveyour </span>
                  </td>
                  <td>
                    <Link to={`/accounts/${datas.account_id}`}>
                      {datas.surveyor}
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td id="td-right">
                    <span>Buyer </span>
                  </td>
                  <td>
                    <Link to={`/accounts/${datas.account_id}`}>
                      {" "}
                      {datas.buyer}
                    </Link>
                  </td>
                  <td id="td-right">
                    <span>Load Port Agent </span>
                  </td>
                  <td>
                    <Link to={`/accounts/${datas.account_id}`}>
                      {" "}
                      {datas.load_port_agent}
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td id="td-right">
                    <span>Supplier </span>
                  </td>
                  <td>
                    <Link to={`/accounts/${datas.supplier_id}`}>
                      {datas.supplier}
                    </Link>
                  </td>
                  <td id="td-right">{/* <span>Locked</span> */}</td>
                  <td>{/* {datas.locked} */}</td>
                </tr>
              </tbody>
            </table>

            <div className="row">
              <div className="col-md-12" id="head">
                <h4 className="heading">Reference Transaction</h4>
                <hr></hr>
              </div>
            </div>
            <table class="table table-bordered account-table tables">
              <tbody>
                <tr>
                  <td id="td-right">
                    <span>Order </span>
                  </td>
                  <td>
                    <Link to={`/order/view-order-details/${datas.order_id}`}>
                      {datas.order}
                    </Link>
                  </td>
                  <td id="td-right">
                    <span>Document Reference Type </span>
                  </td>
                  <td>{datas.document_reference_type}</td>
                </tr>
                <tr>
                  <td id="td-right">
                    <span>Post Shipment Document </span>
                  </td>
                  <td>
                    <Link
                      to={`/postshipment/postshipment-details/${datas.postshipments_id}`}
                    >
                      {datas.post_ship_document}
                    </Link>
                  </td>
                  <td id="td-right">{/* <span>Destination</span> */}</td>
                  <td>{/* {datas.destination} */}</td>
                </tr>
                <tr>
                  <td id="td-right">
                    <span>Buyer Product </span>
                  </td>
                  <td>{datas.buyer_product}</td>
                  <td id="td-right">{/* <span>Destination</span> */}</td>
                  <td>{/* {datas.destination} */}</td>
                </tr>
                <tr>
                  <td id="td-right">
                    <span>TCF No </span>
                  </td>
                  <td>
                    <Link to={`/tcf/tcf-details/${datas.tcf_id}`}>
                      {datas.tcf_no}
                    </Link>
                  </td>
                  <td id="td-right">{/* <span>Destination</span> */}</td>
                  <td>{/* {datas.destination} */}</td>
                </tr>
              </tbody>
            </table>

            <div className="row">
              <div className="col-md-12" id="head">
                <h4 className="heading">Payment/Receipt Information</h4>
                <hr></hr>
              </div>
            </div>
            <table class="table table-bordered account-table tables">
              <tbody>
                <tr>
                  <td id="td-right">
                    <span>Payable DR Acc No </span>
                  </td>
                  <td>{datas.payable_dr_acc_no}</td>
                  <td id="td-right">
                    <span>Payable CR Acc No </span>
                  </td>
                  <td>{datas.payable_cr_acc_no}</td>
                </tr>
                <tr>
                  <td id="td-right">
                    <span>Payable DR Acc </span>
                  </td>
                  <td>{datas.payable_dr_acc}</td>
                  <td id="td-right">
                    <span>Payable CR Acc </span>
                  </td>
                  <td>{datas.payable_cr_acc}</td>
                </tr>
                <tr>
                  <td id="td-right">
                    <span>Payable DR Acc Message </span>
                  </td>
                  <td>{datas.payable_dr_acc_message}</td>
                  <td id="td-right">
                    <span>Payable CR Acc Message </span>
                  </td>
                  <td>{datas.payable_cr_acc_message}</td>
                </tr>
                <tr>
                  <td id="td-right">
                    <span>Created By </span>
                  </td>
                  <td>{datas.created_by}</td>
                  <td id="td-right">
                    <span>Status </span>
                  </td>
                  <td>{datas.status}</td>
                </tr>
                <tr>
                  <td id="td-right">
                    <span>Last Modified By </span>
                  </td>
                  <td>{datas.last_modified_by}</td>
                  <td id="td-right">{/* <span>Documensasase	</span> */}</td>
                  <td>{/* {datas.document_reference_type} */}</td>
                </tr>
              </tbody>
            </table>

            <Row id="table-styles">
              <div className="col-md-12" id="head">
                <h4 className="heading">
                  <span>RW Payments/Receipts LineItem</span>
                </h4>
                <hr></hr>
              </div>
              <table id="tables-pay" className="">
                <thead>
                  <tr>
                    <th>RW Payment/Receipt </th>
                    <th>Payment/Receipt Date </th>
                    <th>Record type</th>
                    <th>Line Item</th>
                    <th>Account</th>
                    <th>Amount </th>
                    <th>Order </th>
                    <th>TCF No </th>
                    <th>Vessel Name</th>
                  </tr>
                </thead>

                {line.length > 0 ? (
                  <tbody>
                    {line.map((y, i) => (
                      <tr>
                        <td>
                          <Link
                            to={`/order/order-receipt-details/${y.rw_pay_receipt_detail_id}`}
                          >
                            {y.rw_payment_receipt}
                          </Link>
                        </td>
                        <td>{y.payment_receipt_date}</td>
                        <td>{y.record_type}</td>

                        <td>{y.line_item}</td>
                        <td>
                          <Link to={`/accounts/${y.account_id}`}>
                            {y.account}
                          </Link>
                        </td>
                        <td>{y.amount}</td>
                        <td>
                          <Link to={`/order/view-order-details/${y.order_id}`}>
                            {y.order}
                          </Link>
                        </td>

                        <td>
                          <Link to={`/tcf/tcf-details/${y.tcf_id}`}>
                            {y.tcf_no}
                          </Link>
                        </td>
                        <td>{y.vessel_name}</td>
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>No data available</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                )}
              </table>
              <p className="edit-cancel">
                <input
                  type="submit"
                  className="account-save"
                  value="Edit"
                  onClick={handleEditClick}
                />{" "}
                <Link to={`/order/view-order-details/${datas.order_id}`}>
                  <input
                    type="submit"
                    className="account-save"
                    value="Cancel"
                  />
                </Link>
              </p>
            </Row>
          </div>
        )}
      </div></div></div>
      <Footer />
    </div>
  );
};

export default Receiptdetails;
